"use strict";
// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// source: notification/notification-service.proto
//
// GitHub:
// https://github.com/search?q=repo%3Agetstep%2Fserver+path%3Aproto%2Fnotification%2Fnotification-service.proto&type=code
Object.defineProperty(exports, "__esModule", { value: true });
exports.NotificationServiceClient = exports.subscribeToPushRequestTypeToJSON = exports.subscribeToPushRequestTypeFromJSON = exports.SendTestNotificationResponse = exports.SendTestNotificationRequest = exports.UnsubscribeToPushResponse = exports.UnsubscribeToPushRequest = exports.SubscribeToPushResponse = exports.SubscribeToPushRequest = exports.SubscribeToPushRequestType = void 0;
/* eslint-disable */
const rpc_1 = require("@getstep/proto-lib/rpc");
const notification_model_1 = require("./notification-model");
const protobufPackage = 'com.step.notification.proto';
var SubscribeToPushRequestType;
(function (SubscribeToPushRequestType) {
    SubscribeToPushRequestType["Expo"] = "Expo";
    /**
     * FCM - Firebase Cloud Messaging
     */
    SubscribeToPushRequestType["FCM"] = "FCM";
    /**
     * APN - Apple Push Notification
     */
    SubscribeToPushRequestType["APN"] = "APN";
    /**
     * TEST - Used for testing, not going anywhere.
     */
    SubscribeToPushRequestType["TEST"] = "TEST";
    SubscribeToPushRequestType["UNRECOGNIZED"] = "UNRECOGNIZED";
})(SubscribeToPushRequestType || (exports.SubscribeToPushRequestType = SubscribeToPushRequestType = {}));
function createBaseSubscribeToPushRequest() {
    return { token: '', type: SubscribeToPushRequestType.Expo, instanceId: '' };
}
exports.SubscribeToPushRequest = {
    fromJSON(object) {
        const message = {
            token: isSet(object.token) ? globalThis.String(object.token) : '',
        };
        if (isSet(object.type)) {
            message.type = subscribeToPushRequestTypeFromJSON(object.type);
        }
        if (isSet(object.instanceId)) {
            message.instanceId = globalThis.String(object.instanceId);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.token !== '') {
            obj.token = message.token;
        }
        if (message.type !== undefined && message.type !== SubscribeToPushRequestType.Expo) {
            obj.type = subscribeToPushRequestTypeToJSON(message.type);
        }
        if (message.instanceId !== undefined && message.instanceId !== '') {
            obj.instanceId = message.instanceId;
        }
        return obj;
    },
    create(base) {
        return exports.SubscribeToPushRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseSubscribeToPushRequest();
        message.token = object.token ?? '';
        message.type = object.type ?? SubscribeToPushRequestType.Expo;
        message.instanceId = object.instanceId ?? '';
        return message;
    },
};
function createBaseSubscribeToPushResponse() {
    return {};
}
exports.SubscribeToPushResponse = {
    fromJSON(_) {
        const message = {};
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    create(base) {
        return exports.SubscribeToPushResponse.fromPartial(base ?? {});
    },
    fromPartial(_) {
        const message = createBaseSubscribeToPushResponse();
        return message;
    },
};
function createBaseUnsubscribeToPushRequest() {
    return { instanceId: '' };
}
exports.UnsubscribeToPushRequest = {
    fromJSON(object) {
        const message = {
            instanceId: isSet(object.instanceId) ? globalThis.String(object.instanceId) : '',
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.instanceId !== '') {
            obj.instanceId = message.instanceId;
        }
        return obj;
    },
    create(base) {
        return exports.UnsubscribeToPushRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseUnsubscribeToPushRequest();
        message.instanceId = object.instanceId ?? '';
        return message;
    },
};
function createBaseUnsubscribeToPushResponse() {
    return {};
}
exports.UnsubscribeToPushResponse = {
    fromJSON(_) {
        const message = {};
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    create(base) {
        return exports.UnsubscribeToPushResponse.fromPartial(base ?? {});
    },
    fromPartial(_) {
        const message = createBaseUnsubscribeToPushResponse();
        return message;
    },
};
function createBaseSendTestNotificationRequest() {
    return { delayMs: '0' };
}
exports.SendTestNotificationRequest = {
    fromJSON(object) {
        const message = {};
        if (isSet(object.delayMs)) {
            message.delayMs = globalThis.String(object.delayMs);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.delayMs !== undefined && message.delayMs !== '0') {
            obj.delayMs = message.delayMs;
        }
        return obj;
    },
    create(base) {
        return exports.SendTestNotificationRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseSendTestNotificationRequest();
        message.delayMs = object.delayMs ?? '0';
        return message;
    },
};
function createBaseSendTestNotificationResponse() {
    return {};
}
exports.SendTestNotificationResponse = {
    fromJSON(_) {
        const message = {};
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    create(base) {
        return exports.SendTestNotificationResponse.fromPartial(base ?? {});
    },
    fromPartial(_) {
        const message = createBaseSendTestNotificationResponse();
        return message;
    },
};
function subscribeToPushRequestTypeFromJSON(object) {
    switch (object) {
        case 0:
        case 'Expo':
            return SubscribeToPushRequestType.Expo;
        case 1:
        case 'FCM':
            return SubscribeToPushRequestType.FCM;
        case 2:
        case 'APN':
            return SubscribeToPushRequestType.APN;
        case 3:
        case 'TEST':
            return SubscribeToPushRequestType.TEST;
        case -1:
        case 'UNRECOGNIZED':
        default:
            return SubscribeToPushRequestType.UNRECOGNIZED;
    }
}
exports.subscribeToPushRequestTypeFromJSON = subscribeToPushRequestTypeFromJSON;
function subscribeToPushRequestTypeToJSON(object) {
    switch (object) {
        case SubscribeToPushRequestType.Expo:
            return 'Expo';
        case SubscribeToPushRequestType.FCM:
            return 'FCM';
        case SubscribeToPushRequestType.APN:
            return 'APN';
        case SubscribeToPushRequestType.TEST:
            return 'TEST';
        case SubscribeToPushRequestType.UNRECOGNIZED:
        default:
            return 'UNRECOGNIZED';
    }
}
exports.subscribeToPushRequestTypeToJSON = subscribeToPushRequestTypeToJSON;
class NotificationServiceClient {
    rpc;
    name = 'com.step.notification.proto.NotificationService';
    type = rpc_1.ServiceType.PUBLIC;
    path = '/notify';
    methods = [{
            name: 'subscribeToPush',
            requestType: exports.SubscribeToPushRequest,
            responseType: exports.SubscribeToPushResponse,
            authenticationOptions: { level: rpc_1.AuthLevel.LOW },
        }, {
            name: 'unsubscribeToPush',
            requestType: exports.UnsubscribeToPushRequest,
            responseType: exports.UnsubscribeToPushResponse,
            authenticationOptions: { level: rpc_1.AuthLevel.LOW },
        }, {
            name: 'sendTestNotification',
            requestType: exports.SendTestNotificationRequest,
            responseType: exports.SendTestNotificationResponse,
            authenticationOptions: { level: rpc_1.AuthLevel.LOW },
        }, {
            name: 'noOp',
            requestType: notification_model_1.NoOpRequest,
            responseType: notification_model_1.NoOpResponse,
            authenticationOptions: { level: rpc_1.AuthLevel.LOW },
        }];
    constructor(rpc) {
        this.rpc = rpc;
    }
    subscribeToPush(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[0],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
    unsubscribeToPush(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[1],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
    sendTestNotification(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[2],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
    /**
     * For proto messages that we use in notifications to expose them to the SDK.
     */
    noOp(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[3],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
}
exports.NotificationServiceClient = NotificationServiceClient;
function isSet(value) {
    return value !== null && value !== undefined;
}
//# sourceMappingURL=notification-service.js.map